goog.provide("shadow.js.shim.module$src$svg$chevron$chevron_left_svg$default");
shadow.js.shim.module$src$svg$chevron$chevron_left_svg$default = shadow.js.shim.module$src$svg$chevron$chevron_left_svg.default;
